//removeIf(production)
import ExternalStatus from "../enums/external-status";
//endRemoveIf(production)

class ClaroluzError extends Error {
    public status: ExternalStatus;

    constructor(message: string, status: ExternalStatus) {
        super(message);
        this.name = 'ClaroluzError';
        this.status = status;
    }
}

//removeIf(production)
export default ClaroluzError;
//endRemoveIf(production)